import { render, staticRenderFns } from "./SetPasswordPage.vue?vue&type=template&id=70b0998a&scoped=true&"
import script from "./SetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./SetPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0998a",
  null
  
)

export default component.exports